"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemClock = void 0;
exports.systemClock = {
    now() {
        return new Date();
    },
    nowIso() {
        return new Date().toISOString();
    },
};
//# sourceMappingURL=clock.js.map